// @flow

import { Flex } from '@rebass/grid';
import withLonghand from './withFlexLonghand';
import type { LonghandProps } from './withFlexLonghand';

export default withLonghand<LonghandProps>(Flex);
